module.exports = __webpack_public_path__ + "static/4a385095073f8ca6718d58712959ae53deddcf2ea90c2fc815f98f72372c3571-cc07bb8f278b8f87e9b5af104f57c45d.png";